import { Grid } from '@mui/material';
import layout from '../../styles/layout.module.css';
import {  IRadarChart } from '../../interfaces/ciem';

export const RadarChartSection = ({ chartData } : {chartData : IRadarChart }) => {
    return (
        <Grid container className={layout.radarContainer}>
            <img
                alt={'In-Ear Monitor radar chart'}
                src={chartData.image}
                className={layout.radarContainer}
            />
        </Grid>
    );
};
